import {useEffect, useState} from 'react';
import {FormField} from '@service/scripts/components/contentful/contactform_v2/FormField.jsx';
import {Button, IconButton} from 'bonprix-design-system';


export function AdditionalFields({
                                     parentField,
                                     formValues,
                                     setFormValues,
                                     formErrors,
                                     handleChange,
                                     additionalFieldsGroups,
                                     setAdditionalFieldsGroups,
                                 }) {

    const [isButtonDisabled, setIsButtonDisabled] = useState(false);

    useEffect(() => {
        const allGroupsHaveValue = additionalFieldsGroups?.every((fieldGroup, index) => {
            return fieldGroup?.some((field) => {
                const value = formValues[field.name]?.[index] ?? null;
                return value != null;
            });
        });

        setIsButtonDisabled(!allGroupsHaveValue || additionalFieldsGroups.length >= 5);
    }, [additionalFieldsGroups, formValues]);

    const handleRemoveButtonClick = (groupIndex) => {
        const newAdditionalFieldGroups = additionalFieldsGroups.filter((_, i) => i !== groupIndex);
        setAdditionalFieldsGroups(newAdditionalFieldGroups);
    };

    const handleAddMoreButtonClick = (fieldGroup) => {
        const emptyGroup = fieldGroup.map(field =>
            ({
                ...field,
                value: ''
            })
        );
        setAdditionalFieldsGroups([...additionalFieldsGroups, emptyGroup]);
    };


    return additionalFieldsGroups.map((fieldGroup, index) => {
        return <AdditionalFieldGroup fieldGroup={fieldGroup} parentField={parentField}
                                     additionalFieldsGroups={additionalFieldsGroups}
                                     handleRemoveButtonClick={handleRemoveButtonClick}
                                     handleAddMoreButtonClick={handleAddMoreButtonClick}
                                     formValues={formValues}
                                     formErrors={formErrors}
                                     handleChange={handleChange}
                                     key={`${parentField.id}-${index}`}
                                     groupIndex={index}
                                     isButtonDisabled={isButtonDisabled} />;
    });

}

function AdditionalFieldGroup({
                                  fieldGroup,
                                  additionalFieldsGroups,
                                  groupIndex,
                                  formErrors,
                                  formValues,
                                  handleChange,
                                  parentField,
                                  handleRemoveButtonClick,
                                  handleAddMoreButtonClick,
                                  isButtonDisabled
                              }) {
    const [isLastElement, setIsLastElement] = useState(false);
    const [isFirstElement, setIsFirstElement] = useState(false);
    useEffect(() => {
        setIsLastElement(additionalFieldsGroups.indexOf(fieldGroup) === additionalFieldsGroups.length - 1);
        setIsFirstElement(additionalFieldsGroups.indexOf(fieldGroup) === 0);
    }, [additionalFieldsGroups]);

    if (!fieldGroup || fieldGroup.length === 0) {
        return null;
    }

    if (!parentField.enableAddMoreButton) {
        return fieldGroup.map((field, fieldIndex) => {
            return <FormField formField={field} formErrors={formErrors} formValues={formValues}
                              handleChange={handleChange} index={groupIndex}
                              key={`${field.name}_${groupIndex}_${fieldIndex}`} />;
        });
    }

    return <div className="form-row" key={groupIndex}>
        <div className="flex gap-2">
            <div className="grow">
                {fieldGroup.map((field, fieldIndex) => {
                    return <FormField formField={field} formErrors={formErrors} formValues={formValues}
                                      handleChange={handleChange}
                                      index={groupIndex}
                                      key={`${field.name}_${groupIndex}_${fieldIndex}`} />;
                })}
            </div>
            <div>
                {!isFirstElement && (
                    <IconButton
                        icon="trash-bin"
                        label="Eintrag entfernen"
                        variant="secondary"
                        onClick={() => handleRemoveButtonClick(groupIndex)}
                    />
                )}
            </div>
        </div>

        {isLastElement && <div className="flex justify-end">
            <Button contentWidth onClick={() => handleAddMoreButtonClick(fieldGroup)}
                    disabled={isButtonDisabled}>
                {parentField.addMoreButtonLabel}
            </Button>
        </div>}
    </div>;
}
